/**
 * @file
 * Measures article sidebars for the bottom-sticky CSS layout.
 */

(function (Drupal, once) {
  'use strict';

  const selector = '.blog-article__sidebar';
  const onceId = 'blog-article-sticky-sidebar';
  const observers = new WeakMap();

  // Include the context itself when AJAX inserts a sidebar as the root element.
  function getSidebars(context) {
    const sidebars = Array.from(context.querySelectorAll(selector));

    if (context.nodeType === 1 && context.matches(selector)) {
      sidebars.unshift(context);
    }

    return sidebars;
  }

  Drupal.behaviors.blogArticleStickySidebar = {
    attach(context) {
      if (!('ResizeObserver' in window)) {
        return;
      }

      once(onceId, getSidebars(context)).forEach((sidebar) => {
        const updateHeight = () => {
          const height = sidebar.getBoundingClientRect().height;

          sidebar.style.setProperty('--sidebar-height', `${height}px`);
          sidebar.classList.add('is-sticky-ready');
        };

        const observer = new ResizeObserver(updateHeight);
        observers.set(sidebar, observer);
        observer.observe(sidebar, { box: 'border-box' });

        // Set the initial height before waiting for a resize notification.
        updateHeight();
      });
    },

    detach(context, settings, trigger) {
      if (trigger !== 'unload') {
        return;
      }

      once.remove(onceId, getSidebars(context)).forEach((sidebar) => {
        const observer = observers.get(sidebar);

        if (observer) {
          observer.disconnect();
          observers.delete(sidebar);
        }

        sidebar.style.removeProperty('--sidebar-height');
        sidebar.classList.remove('is-sticky-ready');
      });
    },
  };
})(Drupal, once);
